import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient, CancelledReasonInfo } from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class CancellationReasonService {
  private readonly sdk = inject(ApiClient);

  getCancellationReasons(): Observable<CancelledReasonInfo[]> {
    return this.sdk.getCancellationReasons();
  }
}
